import { getFirstVariantId } from './getProductJSON';
import { getLocalePrefix } from './localization';

const buildAttributesQueryString = (dictionary) => {
  if (Object.getOwnPropertyNames(dictionary).length < 0) {
    return '';
  }

  return Object.keys(dictionary)
    .map((key) => {
      if (key === 'discount') {
        return `${key}=${dictionary[key]}`;
      } else {
        return `attributes[${encodeURIComponent(key)}]=${encodeURIComponent(
          dictionary[key]
        )}`;
      }
    })
    .join('&');
};

export default function buildCheckoutPermalink(
  variantId,
  quantity = 1,
  paramDictionary = {}
) {
  const queryString = buildAttributesQueryString(paramDictionary);

  if (quantity < 1) {
    return '#';
  }

  const localePrefix = getLocalePrefix();
  return `https://${window.location.hostname}/${localePrefix}cart/${variantId}:${quantity}?${queryString}`;
}

const checkoutButtonHandler = (event) => {
  const ENTER_KEY = 13;
  if (
    event.type === 'click' ||
    event.which === ENTER_KEY ||
    event.keyCode === ENTER_KEY
  ) {
    window.location.href = event.target.href;
  }
};

export function updateCheckoutButton(
  sampleList = [],
  selector = 'a.upg-checkout-button',
  scopeElement
) {
  const scope = scopeElement || document;

  const buyButton = scope.querySelector(selector);
  const variantId = getFirstVariantId();
  const checkoutURL = buildCheckoutPermalink(variantId, sampleList.length, {
    samples: sampleList.join(','),
  });

  buyButton.href = checkoutURL;

  // Remove preexisting handlers to prevent navigation to stale links
  // and/or memory leaks
  buyButton.removeEventListener('click', checkoutButtonHandler);
  buyButton.removeEventListener('keyUp', checkoutButtonHandler);

  buyButton.addEventListener('click', checkoutButtonHandler);
  buyButton.addEventListener('keyUp', checkoutButtonHandler);
}
